// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const FULL_ANNOUNCEMENT = "Cel\u00fd oznam";
export const SHRINK_ANNOUNCEMENT = "Zavri oznam";
